module.exports = __webpack_public_path__ + "static/img/ct_checked.13fe5f39.png";